import styled from 'styled-components';

export const AssignLaterModalOuter = styled.div(
  () => `
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  top: 0px;
  background-color: rgba(0; 0; 0; 0.5);
  left: 0px;
  align-items: center
`
);

export const AssignLaterModalInner = styled.div`
  width: 320px;
  height: 200px;
  background-color: white;
  border-radius: 4px;
  margin: auto;
  display: flex;
  justify-content: center;
  & div[class*='ButtonWrapper'] {
    border-radius: 4px;
  }
`;



// WEBPACK FOOTER //
// ./components/assign-later/assign-later.styled.js